import {AxiosError} from "axios";
import {useQuery} from '@tanstack/react-query'
import api from "../../api/api";
import {isConstructorBlocks} from "../../types/ConstructorBlocks";

const partsEndpoint = '/builder/complectations';

export const useGetConstructorBlocks = (modelId: string | null, sizeId: string | null) => {
    return useQuery(
        [partsEndpoint, modelId, sizeId],
        () => api.get(partsEndpoint, {params: {modelId, sizeId}})
            .then((response: unknown) => {

                if (!response || !isConstructorBlocks(response)) {
                    throw new AxiosError('Complectation Request have wrong response', 'WRONG_RESPONSE_BLOCKS');
                }

                if (!response.complectations.length) {
                    throw new AxiosError('Complectation Request have empty complectations list', 'EMPTY_RESPONSE_BLOCKS');
                }

                return response;
            }).catch(err => {
                throw err;
            }),
        {
            enabled: !!modelId && !!sizeId,
            keepPreviousData: false,
            select: (data) => ({
                complectations: data.complectations || [],
                accessories: data.accessories || [],
            }),
        }
    );
};
